import { Currencies } from '@constants/miscellaneous';

export enum MovementFlowType {
  // keep under 32 charcters because of firebase events, they are loged in movement-flow page with a prefix
  WITHDRAWAL = 'withdrawal',
  CASH_OUT_PORTFOLIO = 'withdrawal_from_portfolio',
  CASH_OUT_STOCKS = 'withdrawal_from_stocks',
  TRANSFER_STOCKS_TO_PORTFOLIO = 'transfer_stocks_to_portfolio',
  TRANSFER_PORTFOLIO_TO_STOCKS = 'transfer_portfolio_to_stocks',
  TRANSFER_BETWEEN_PORTFOLIOS = 'transfer_between_portfolios',
}

export enum MovementStep {
  PORTFOLIO_SELECTION = 'portfolio_selection',
  SELL_OPTION = 'sell_option',
  ASSET_SELECTION = 'asset_selection',
  AMOUNT = 'amount',
  WITHDRAWAL_OPTIONS = 'withdrawal_options',
  DEPOSIT_OPTIONS = 'deposit_options',
  BUY_PORTFOLIO = 'buy_portfolio',
  SUMMARY = 'summary',
}

export enum MovementFlowDataKey {
  SELECTED_PORTFOLIO_ID = 'selectedPortfolioId',
  SELECTED_SELL_OPTION = 'selectedSellOption',
  SELECTED_ASSET_ID = 'selectedAssetId',
  SELECTED_AMOUNT = 'selectedAmount',
  SELECTED_WITHDRAWAL_OPTION = 'selectedWithdrawalOption',
  SELECTED_DEPOSIT_OPTION = 'selectedDepositOption',
  SELECTED_BUY_PORTFOLIO = 'selectedBuyPortfolio',
  SELECTED_SUMMARY = 'selectedSummary',
}

export enum SellOption {
  ONE_ASSET = 'ONE_ASSET',
  ALL_ASSETS = 'ALL_ASSETS',
  CASH_EXCESS = 'CASH_EXCESS',
}

export const MAX_LIMIT_ERROR_MESSAGE: Record<SellOption, string> = {
  [SellOption.ONE_ASSET]: 'Monto ingresado es mayor que el valor de la acción',
  [SellOption.ALL_ASSETS]: 'Monto ingresado es mayor que el valor del portafolio',
  [SellOption.CASH_EXCESS]: 'Monto ingresado es mayor que el exceso de caja',
};

export enum WithdrawalOption {
  WITHDRAW_PORTFOLIO = 'WITHDRAW_PORTFOLIO',
  WITHDRAW_STOCKS = 'WITHDRAW_STOCKS',
  TRANSFER_TO_PORTFOLIO = 'TRANSFER_TO_PORTFOLIO',
  TRANSFER_TO_STOCKS = 'TRANSFER_TO_STOCKS',
  TRANSFER_BETWEEN_PORTFOLIOS = 'TRANSFER_BETWEEN_PORTFOLIOS',
  KEEP_SAFE_PORTFOLIO = 'KEEP_SAFE_PORTFOLIO',
  KEEP_SAFE_STOCKS = 'KEEP_SAFE_STOCKS',
}

export interface IMovementFlowData {
  selectedPortfolioId?: string;
  selectedSellOption?: SellOption;
  selectedAssetId?: string;
  selectedAmount?: number;
  selectedWithdrawalOption?: WithdrawalOption;
  selectedDepositOption?: string;
  selectedBuyPortfolio?: string;
  selectedSummary?: string;
  isTotalSelected?: boolean;
}

export interface IMovementFlowConfig {
  title: string;
  requiredData?: Array<keyof IMovementFlowData>;
  fixedData?: IMovementFlowData;
  displayConfirmModal?: boolean;
  steps: {
    skipCondition?: (flowData: IMovementFlowData) => boolean;
    name: MovementStep,
    options?: any,
    resultKeyInFlowData?: MovementFlowDataKey,
    displayCancelButton?: boolean,
  }[];
}

export interface IMovementFlowSummaryAsset {
  name: string;
  amount: number;
  assetId?: string;
  price?: number;
  shares?: number;
  currency?: Currencies;
}

export interface IMovementFlowSummaryBottomMessage {
  type: MovementFlowType;
  side: 'buying' | 'selling';
  attributes: any;
}

export enum SummarySectionTitle {
  SELL = 'Montos estimados a vender',
  BUY = 'Montos estimados a comprar',
  COMPLETED_SELL = 'Montos vendidos',
  COMPLETED_BUY = 'Montos comprados',
}

export interface IMovementFlowSummarySection {
  title: SummarySectionTitle;
  titleLeftIcon?: string;
  assets?: IMovementFlowSummaryAsset[];
  separateCashText?: string;
  bottomMessage?: IMovementFlowSummaryBottomMessage;
}

export interface IMovementFlowSummaryTopDescription {
  type: MovementFlowType;
  attributes: any;
}

export interface IMovementFlowSummary {
  topDescription?: IMovementFlowSummaryTopDescription;
  sellingSection?: IMovementFlowSummarySection;
  buyingSection?: IMovementFlowSummarySection;
  confirmInformation?: string;
}

export enum MovementFlowStartAtStepSlideNumber {
  TRANSFER_PORTFOLIO_TO_STOCKS_SUMMARY = 3,
}

export interface ITransferDateOptions {
  isOnlyCashExcess?: boolean;
  isDrivewealth?: boolean;
  exactTransferDate?: boolean;
  dollarSale?: boolean;
  isSellingDollars?: boolean;
  isTransferToStocksWithdrawal?: boolean;
}
